import { translateObject } from '@jsverse/transloco';

import { Radio } from 'app/models/radio';
import {
  Decimals,
  PlotType,
  PredictorView,
  StepValue,
} from '../widget-predictive/widget-predictive.component';

interface DecimalRadios {
  '0-decimal': string;
  '1-decimal': string;
  '2-decimals': string;
}

interface ScatterValueRadios {
  average: string;
  median: string;
}

interface StepValueRadios {
  '1-point': string;
  '5-points': string;
  '10-points': string;
}

interface ViewRadios {
  crosstab: string;
  predictor: string;
}

export const getRadios = (): {
  stepValueRadios: Radio<StepValue>[];
  decimalsRadios: Radio<Decimals>[];
  viewRadios: Radio<PredictorView>[];
  scatterValueRadios: Radio<PlotType>[];
} => {
  const stepValueTrans = translateObject(
    'predictive-chart-options.step-value-radios'
  ) as StepValueRadios;
  const stepValueRadios: Radio<StepValue>[] = [
    { value: '1%', label: stepValueTrans['1-point'] },
    { value: '5%', label: stepValueTrans['5-points'] },
    { value: '10%', label: stepValueTrans['10-points'] },
  ];

  const decimalTrans = translateObject('predictive-chart-options.decimal-radios') as DecimalRadios;
  const decimalsRadios: Radio<Decimals>[] = [
    { value: '0', label: decimalTrans['0-decimal'] },
    { value: '1', label: decimalTrans['1-decimal'] },
    { value: '2', label: decimalTrans['2-decimals'] },
  ];

  const viewTrans = translateObject('predictive-chart-options.view-radios') as ViewRadios;
  const viewRadios: Radio<PredictorView>[] = [
    { value: 'predictor', label: viewTrans.predictor },
    { value: 'crosstab', label: viewTrans.crosstab },
  ];

  const scatterValueTrans = translateObject(
    'predictive-chart-options.scatter-value-radios'
  ) as ScatterValueRadios;
  const scatterValueRadios: Radio<PlotType>[] = [
    { value: 'Average', label: scatterValueTrans.average },
    { value: 'Median', label: scatterValueTrans.median },
  ];

  return { stepValueRadios, decimalsRadios, viewRadios, scatterValueRadios };
};
